import { useState, useEffect, useCallback } from "react";
import Chart from "chart.js";
import Header from "components/Headers/chatHeader.js";
import { CMM } from '../../Lib/Cmm.js';
import axios from 'axios';
import { auto, right } from '@popperjs/core';
import { chartOptions, parseOptions, } from "variables/charts.js";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import icon_square from "../../assets/img/icons/common/icon_square.svg";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { ChromePicker } from 'react-color';
import { toast, ToastContainer } from 'react-toastify';
import { fetchAxios, postAxios, postNoauth, postWithFiles } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';
import 'react-toastify/dist/ReactToastify.css';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";

const Profile = (props) => {

  const [userName, setUserName] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState([]);
  const [email, setEmail] = useState([]);
  const [comp_nm, setCompNm] = useState([]);

  useEffect(() => {

    getProfile();

  }, [])


  //챗봇 프로필 업데이트
  const getProfile = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/user_profile`,
      {})
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);

          setUserName(res[0].user_name);
          setPhoneNumber(res[0].phone_number);
          setEmail(res[0].email);
          setCompNm(res[0].comp_nm);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [userName, phoneNumber, email, comp_nm]);

  //프로필 업데이트
  const profileEdit = useCallback(async () => {

    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/user_profile_edit`,
      {
        comp_nm: comp_nm,
        user_name: userName,
        phone_number: phoneNumber,
        email: email,
      })
      .then((res) => {
        if (res != 'ERROR') {
          //토스트 메시지
          toast.success('성공적으로 변경되었습니다.', {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          getProfile();
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })

  }, [comp_nm, userName, phoneNumber, email]);


  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      {/* Page content */}
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>
        <Card className="bg-white">
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                관리자 프로필</h1>
              {/* <div className=""
                style={{ color: '#727272' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=""
                style={{ color: '#727272' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div> */}
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                관리자 프로필</h2>
              {/* <div className="   "
                style={{ color: '#727272', fontSize: '14px' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=" "
                style={{ color: '#727272', fontSize: '14px' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div> */}
            </div>
          </CardHeader>
          <CardBody className="p-0 bg-white ">

            <Card className="">
              <CardBody className='p-0 m-0' style={{ height: '50vh', overflowY: 'auto', maxHeight: '580px' }}>
                <div className="pt-2 pl-2">
                  <Col lg="12" className="py-2">
                    <label className="form-control-label text-dark "
                      style={{ fontSize: '17px' }}>
                      기업명
                    </label>
                    <span
                      className="cursor-pointer opacity-0"
                    >
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 ml-1">
                        <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#D9D9D9" />
                      </svg>
                    </span>
                    <span className="form-control-label text-md ml-1 text-black-50">챗봇 프로필 상단에 표시되는 기업명칭입니다.</span>
                  </Col>
                  <Col lg="8" className="pl-4">
                    <Input
                      className="form-control-alternative mb-2 border shadow-none text-dark"
                      value={comp_nm}
                      placeholder=""
                      onChange={(e) => {
                        setCompNm(e.target.value);
                      }}
                    />
                  </Col>
                  <Col lg="12" className="py-2">
                    <label className="form-control-label text-dark "
                      style={{ fontSize: '17px' }}>
                      이름
                    </label>
                  </Col>
                  <Col lg="8" className="pl-4">
                    <Input
                      className="form-control-alternative mb-2 border shadow-none text-dark"
                      value={userName}
                      placeholder=""
                      onChange={(e) => {
                        setUserName(e.target.value);
                      }}
                    />
                  </Col>
                  <Col lg="12" className="py-2">
                    <label className="form-control-label text-dark "
                      style={{ fontSize: '17px' }}>
                      전화번호
                    </label>
                  </Col>
                  <Col lg="8" className="pl-4">
                    <Input
                      className="form-control-alternative mb-2 border shadow-none text-dark"
                      value={phoneNumber}
                      placeholder=""
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                      }}
                    />
                  </Col>
                  <Col lg="12" className="py-2">
                    <label className="form-control-label text-dark "
                      style={{ fontSize: '17px' }}>
                      이메일
                    </label>
                    {/* <span
                      className="cursor-pointer opacity-0"
                    >
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 ml-1">
                        <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#D9D9D9" />
                      </svg>
                    </span>
                    <span className="form-control-label text-md ml-1 text-black-50">채팅 알림을 수신할 이메일을 입력해주세요.</span> */}
                  </Col>
                  <Col lg="8" className="pl-4">
                    <Input
                      className="form-control-alternative mb-2 border shadow-none text-dark"
                      value={email}
                      placeholder=""
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </Col>
                  <Col lg="8" className="text-right mt-3" >
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        profileEdit();
                      }}
                      className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white ml-4"
                      style={{ backgroundColor: '#3094FF', fontWeight: 'normal' }}>
                      저장
                    </button>
                  </Col>
                </div>
              </CardBody>

            </Card>
          </CardBody>
        </Card >
      </Container >
    </>
  );
}

export default Profile;
